<template>
	<div>
		<div class="mh—container flex-cb">
			<div class="col-center header-title">
				<!-- <div class="logo" v-if="systemType.logo">
					<img :src="systemType.logo" alt="" />
				</div> -->
				<div class="title">
					{{systemType.title}}
					<!-- <img :src="systemType.titleImg" alt="" /> -->
				</div>
				<div class="title-col">{{systemType.title}}</div>
			</div>
			<div class="right col-center">
				<el-dropdown ref="dropdown" placement="bottom" @command="handleCommand">
					<div class="avatar">
						<img src="../../assets/default_avatar.png" alt="" />
					</div>
					<el-dropdown-menu slot="dropdown">
						<!-- <el-dropdown-item command="a">修改个人信息</el-dropdown-item> -->
						<el-dropdown-item command="b">修改密码</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<div class="username">
					{{userinfo.name}}
				</div>
				<div class="logout" @click="logout">[退出登录]</div>
			</div>
		</div>
		<!-- 面包屑导航 -->
		<div class="breadcrumbs-container col-center flex-sb wrap">
			<div class="col-center">
				<div class="icon">
					<i class="el-icon-location"></i>
					<!-- <img src="../../assets/icon_position.png" alt="" /> -->
				</div>
				<div style="flex-shrink: 0;">
					当前位置：
				</div>
				<div class="group col-center wrap">
					<!-- :class="{current:item.name === currentRoute.name}"  -->
					<div class="item" :class="{current:item.name === currentRoute.name}" @click="jump(item)"
						v-for="(item,index) in breadcrumbsList" :key="index">
						{{item.title}}
						<span v-if="index < breadcrumbsList.length -1">>>&nbsp;</span>
					</div>
				</div>
			</div>
			<div class="col-center">
				<div class="seeManual" @click="$router.push('/draw-lots')" v-if="userinfo.id == 3406 || userinfo.id == 4308">省赛抽签</div>
				<div class="seeManual" @click="opener">系统文档</div>
			</div>
		</div>
		<!-- 修改个人信息 -->
		<!-- <el-dialog :visible.sync="infoDialogVisible" :show-close="!isFirst" width="30%" top="5vh"
			:close-on-click-modal="!isFirst">
			<div class="dialog-head flex-sb" slot="title">
				<div>修改个人信息</div>
				<div v-if="!isFirst"><i class="el-icon-close"></i></div>
			</div>
			<div class="dialog-content">
				<el-form :model="ruleForm" :rules="rules" ref="infoForm" label-position="top" class="demo-ruleForm">
					<el-form-item label="姓名" prop="name">
						<el-input placeholder="请输入姓名" v-model="ruleForm.name"></el-input>
					</el-form-item>
					<el-form-item label="身份证号" prop="id_card" v-if="authority === 'expert'">
						<el-input placeholder="请输入身份证号" v-model="ruleForm.id_card"></el-input>
					</el-form-item>
					<el-form-item label="所在单位" prop="work_unit" v-if="authority === 'expert'">
						<el-input placeholder="填写所在单位" v-model="ruleForm.work_unit"></el-input>
					</el-form-item>
					<el-form-item label="职称" prop="level">
						<el-select style="width: 100%;" v-model="ruleForm.level" placeholder="请选择职称">
							<el-option :label="item.name" :value="item.id" v-for="(item,index) in commonData.level"
								:key="index"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="职务" prop="job" v-if="authority === 'expert'">
						<el-input placeholder="填写职务" v-model="ruleForm.job"></el-input>
					</el-form-item>
					<el-form-item label="学科门类" prop="subject" v-if="authority === 'expert'">
						<el-select style="width: 100%;" v-model="ruleForm.subject" placeholder="填写学科门类">
							<el-option :label="item.name" :value="item.id"
								v-for="(item,index) in commonData.subject"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="专业" prop="major" v-if="authority === 'expert'">
						<el-input placeholder="填写专业" v-model="ruleForm.major"></el-input>
					</el-form-item>
					<el-form-item label="最高学位" prop="degree" v-if="authority === 'expert'">
						<el-select style="width: 100%;" v-model="ruleForm.degree">
							<el-option :label="item.name" :value="item.id" v-for="(item,index) in commonData.education"
								:key="index"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="借记卡号" prop="bank_card" v-if="authority === 'expert'">
						<el-input placeholder="请输入借记卡号" maxlength="19" v-model="ruleForm.bank_card"></el-input>
					</el-form-item>
					<el-form-item label="开户银行" prop="bank" v-if="authority === 'expert'">
						<el-input placeholder="请输入开户银行" v-model.number="ruleForm.bank"></el-input>
					</el-form-item>
					<el-form-item label="手机号" prop="phone">
						<el-input :maxlength="11" placeholder="请输入手机号" v-model.number="ruleForm.phone"></el-input>
					</el-form-item>
					<el-form-item label="邮箱" prop="email">
						<el-input placeholder="请输入邮箱" v-model="ruleForm.email"></el-input>
					</el-form-item>
					<el-form-item label="用户名" prop="nickname">
						<el-input placeholder="请输入用户名" v-model="ruleForm.nickname"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="infoDialogVisible = false" v-if="!isFirst">取 消</el-button>
				<el-button type="primary" @click="editInfo">确 定</el-button>
			</span>
		</el-dialog> -->
		<!-- 修改密码 -->
		<div class="edit-pass">
			<el-dialog :visible.sync="passDialogVisible" width="25%">
				<div class="dialog-head flex-sb" slot="title">
					<div>修改密码</div>
					<div><i class="el-icon-close"></i></div>
				</div>
				<div class="dialog-content">
					<el-form :model="ruleForm" :rules="rules" ref="passForm" label-position="top" class="demo-ruleForm">
						<el-form-item label="邮箱" prop="email">
							<el-input disabled placeholder="请输入邮箱" v-model="ruleForm.email"></el-input>
						</el-form-item>
						<!-- <el-form-item prop="verify_code">
							<div class="flex-cb">
								<div class="verify-code">
									<el-input placeholder="验证码" v-model.number="ruleForm.verify_code"></el-input>
								</div>
								<div style="padding-left: 1.25rem;flex-grow: 1;width: 0;">
									<el-button :disabled="isSend" style="width:100%;height: 3rem;" type="primary" plain
										@click="send">{{isSend ? time+'s后重新获取': '获取验证码'}}</el-button>
								</div>
							</div>
						</el-form-item> -->
						<el-form-item label="新密码" prop="password">
							<el-input placeholder="请输入新密码" v-model="ruleForm.password" show-password></el-input>
						</el-form-item>
						<el-form-item label="确认密码" prop="checkPass">
							<el-input placeholder="请再次输入密码" v-model="ruleForm.checkPass" show-password></el-input>
						</el-form-item>
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="passDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="editPass">确 定</el-button>
				</span>
			</el-dialog>
			<files-list ref="filesListRef"></files-list>
		</div>

	</div>

</template>

<script>
	import {
		sendCode,
		forgetPass,
		editorUserInfo
	} from '@/common/api/user.js'
	import {
		validatePhone,
		validateEmail,
		validateIdCard
	} from '../../utils/reg.js'
	import {
		type
	} from '../../common/config.js'
	import filesList from './files-list'
	export default {
		name: '',
		props: {
			child: {
				type: Array,
				default () {
					return []
				}
			},
		},
		components: {
			filesList
		},
		data() {
			let validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					if (this.ruleForm.checkPass !== '') {
						this.$refs.passForm.validateField('checkPass');
					}
					callback();
				}
			};
			let validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.password) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				infoDialogVisible: false,
				passDialogVisible: false,
				time: 60,
				timer: null,
				isSend: false,
				isFirst: false,
				checked: false,
				ruleForm: {
					name: '',
					id_card: '',
					level: '',
					email: '',
					nickname: '',
					phone: '',
					password: '',
					checkPass: '',
					verify_code: '',
					work_unit: '',
					bank: '',
					bank_card: ''
				},
				rules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					work_unit: [{
						required: true,
						message: '请输入所在单位',
						trigger: 'blur'
					}],
					level: [{
						required: true,
						message: '请选择职称',
						trigger: 'change'
					}],
					id_card: [{
						required: true,
						validator: validateIdCard,
						trigger: 'blur'
					}],
					email: [{
						required: true,
						validator: validateEmail,
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						validator: validatePhone,
						trigger: 'blur'
					}],
					verify_code: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						validator: validatePass,
						trigger: 'blur'
					}],
					checkPass: [{
						required: true,
						validator: validatePass2,
						trigger: 'blur'
					}],
					bank: [{
						required: true,
						message: '请输入开户银行',
						trigger: 'blur'
					}],
					bank_card: [{
						required: true,
						message: '请输入借记卡号',
						trigger: 'blur'
					}],
					nickname: [{
						required: true,
						message: '请输入用户名',
						trigger: 'blur'
					}],
				},
				breadcrumbsList: [],
				currentRoute: {},
				userinfo: {},
				systemType: type
			}
		},
		watch: {
			child: {
				handler(v) {
					this.breadcrumbsList = [...v, {
						title: this.authority === 'expert' && this.currentRoute.meta.expertTitle ? this
							.currentRoute.meta.expertTitle : this.currentRoute.meta.title,
						name: this.currentRoute.name,
						path: this.currentRoute.path,
					}]

				},
				deep: true,
				imediate: true,
			}
		},
		created() {
			// 获取已缓存的路由
			this.currentRoute = this.$route
			this.breadcrumbsList = [{
				title: this.authority === 'expert' && this.currentRoute.meta.expertTitle ? this
					.currentRoute.meta.expertTitle : this.currentRoute.meta.title,
				name: this.currentRoute.name,
				path: this.currentRoute.path,
			}]
			// 获取用户信息
			let userinfo = localStorage.getItem('userinfo')
			if (userinfo) {
				this.userinfo = JSON.parse(userinfo)
				this.ruleForm = JSON.parse(JSON.stringify(this.userinfo))

			} else {
				this.$router.push('/')
			}
			// 获取验证码
			let code = sessionStorage.getItem('vcode')
			if (code && Number(code) > 0) {
				this.time = code
				this.setTime()
			}
			console.log(userinfo,'userinfo')
		},
		mounted() {
			if (this.userinfo.expert_not_update == 1) {
				this.isFirst = true
				this.infoDialogVisible = true
			} else {
				this.isFirst = false
			}
			// if (!this.userinfo.email) {
			// 	this.$message.warning('您还未绑定邮箱，请填写您的邮箱')
			// 	this.infoDialogVisible = true
			// 	this.isFirst = true
			// }
		},
		methods: {
			// 下拉菜单点击
			handleCommand(command) {
				if (command === 'a') {
					this.infoDialogVisible = true
				} else if (command === 'b') {
					this.passDialogVisible = true
				}
				if (this.$refs.dropdown) {
					this.$refs.dropdown.hide();
				}
			},
			// 修改基本信息
			editInfo(formName) {
				this.$refs.infoForm.validate(async (valid) => {
					if (valid) {
						const {
							data
						} = await editorUserInfo(this.ruleForm)
						this.$message.success('修改成功')
						localStorage.setItem("userinfo", JSON.stringify(this.ruleForm))
						this.userinfo = this.ruleForm
						this.infoDialogVisible = false
						if (this.authority === 'expert') {
							this.userinfo.expert_not_update = 0
							this.isFirst = false
						}
						localStorage.setItem('userinfo', JSON.stringify(this.userinfo))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			// 修改密码
			editPass() {
				this.$refs.passForm.validate(async (valid) => {
					if (valid) {
						const {
							data
						} = await forgetPass(this.ruleForm)
						this.$message.success('密码重置成功！请重新登录')
						setTimeout(() => {
							this.logout()
						}, 1000)
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			// 验证码
			setTime() {
				this.isSend = true
				this.timer = setInterval(() => {
					this.time--
					sessionStorage.setItem('vcode', this.time)
					if (this.time <= 0) {
						setTimeout(() => {
							this.isSend = false
							this.time = 60
							clearInterval(this.timer)
						}, 1000)
					}
				}, 1000)
			},
			send() {
				this.$refs.passForm.validateField('email', (errorMessage) => {
					console.log(errorMessage)
					if (!errorMessage) {
						this.sendCode()
						this.setTime()
					} else {
						console.log('error submit!!');
						return false;
					}
				})
			},
			// 发送验证码
			async sendCode() {
				try {
					const {
						data
					} = await sendCode({
						email: this.ruleForm.email,
						type: 2
					})
					this.$message.success('您的验证码已发送，请注意接收');
				} catch (e) {
					this.$message.error(JSON.stringify(e));
				}
			},
			//退出登录
			logout() {
				localStorage.setItem("userinfo", '')
				localStorage.setItem("access_token", '')
				localStorage.setItem("refresh_token", '')
				this.$router.push("/")
			},
			// 面包屑跳转
			jump(item) {
				this.$router.push(item.path)
			},
			opener() {
				this.$refs.filesListRef.open();
				return
				if (this.storage_manual && this.storage_manual.files.length) {
					window.open(this.storage_manual.files[0].link_url)
				} else {
					this.$message.error('失败');
				}
			}
		}

	}
</script>

<style lang="scss" scoped>
	.edit-pass {
		::v-deep .el-input__inner {
			height: 3rem;
		}
	}

	.verify-code {
		width: 17rem;
	}

	.mh—container {
		background-color: #4389E0;
		padding: 14px 1.875rem;

		.header-title {

			.title-col {
				display: none;
			}

			.logo {
				width: 46px;
				height: 46px;
				flex-shrink: 0;
			}

			.title {
				// height: 4rem;
				// margin-left: .875rem;
				// padding-top: .5rem;
				// box-sizing: border-box;
				font-weight: 800;
				font-size: 32px;
				color: #FFFFFF;
				text-shadow: 0px 2px 10px rgba(131, 157, 190, 0.35);
				padding-left: 10px;
			}

			.title-col {
				display: none;
			}

			img {
				width: 100%;
			}
		}

		.right {
			color: white;

			.avatar {
				width: 46px;
				height: 46px;
				cursor: pointer;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.username {
				font-size: 1rem;
				padding: 0 1.25rem;
				cursor: pointer;
			}

			.logout {
				cursor: pointer;

			}

			.logout:hover {
				text-decoration: underline;
			}
		}

		::v-deep .el-dialog__header {
			background-color: #4389DF;
			padding: 1.125rem 1.25rem;
		}

		::v-deep .el-dialog {
			border-radius: 0.625rem;
			overflow: hidden;
		}

		::v-deep .el-form-item {
			margin-bottom: 0.625rem;
		}

		.dialog-head {
			color: white;
		}

		.dialog-content {
			padding: 0 1.25rem;

		}
	}

	.breadcrumbs-container {
		padding: 12px 1.25rem;
		background-color: white;

		.icon {
			width: 1rem;
			height: 1rem;
			margin-right: 0.625rem;
			flex-shrink: 0;
			color: #4389E0;
			font-size: 20px;
			margin-top: -4px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.group {
			.home {}

			.item {
				cursor: pointer;
			}

			.item:hover {
				text-decoration: underline;
			}

			.home:hover>.hover {
				text-decoration: underline;
				color: #4979ff;
			}

			.item.current {
				color: #4979ff;
			}
		}

		.seeManual {
			text-decoration: underline;
			cursor: pointer;
			padding-right: 20px;
		}

		.seeManual:hover {
			color: #409EFF;
		}
	}

	// 响应式

	@media screen and (min-width: 1200px) {}

	@media screen and (min-width: 923px) and (max-width:1199px) {}

	@media screen and (min-width: 768px) and (max-width:922px) {}

	@media screen and (max-width: 922px) {
		.verify-code {
			width: 14rem;
		}

		.mh—container {

			.header-title {
				display: none;

				.logo {}

				.title {
					display: none;
				}

				.title-col {
					display: block;
					color: white;
					padding-left: 1.25rem;
					font-size: 1.25rem;
					display: block;
					font-weight: bold;
				}
			}

		}

		::v-deep {
			.el-dialog {
				width: 100% !important;
				margin-top: 0 !important;
				border-radius: 0 !important;
			}
		}

		.breadcrumbs-container {
			.seeManual {
				padding-right: 0px;
			}
		}
	}
</style>